import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
const TeamCheckbox = ({
  selectedTeams,
  team,
  canAssignContent,
  onTeamChange
}) => {
  const {
    id,
    name
  } = team;
  return /*#__PURE__*/_jsx(Checkbox, {
    checked: selectedTeams.includes(id),
    readOnly: !canAssignContent,
    onChange: onTeamChange,
    value: id,
    children: name
  });
};
export default TeamCheckbox;